import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { IRIBuffering } from 'data/iriBuffering/iriBuffering.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  processOptionsData: IRIBuffering,
  originalIRIBufferingFormData: IRIBuffering | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  const actionType = AuditActionType.IRI_BUFFERING_EDIT;
  const isEdit = true;

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(processOptionsData, null, isEdit, originalIRIBufferingFormData),
    processOptionsData.NAME,
    AuditService.IRI_BUFFERING,
    actionType,
  );
  return auditDetails as AuditDetails;
}
